// extracted by mini-css-extract-plugin
export var actions = "_dm-g";
export var benefitCard = "_dm-b";
export var benefitIcon = "_dm-d";
export var benefitLabel = "_dm-f";
export var benefits = "_dm-a";
export var benefitsSection = "_dm-8";
export var bodyText = "_dm-7";
export var closeButton = "_dm-2";
export var content = "_dm-3";
export var eyebrow = "_dm-4";
export var heading = "_dm-5";
export var image = "_dm-i";
export var imagePanel = "_dm-h";
export var modal = "_dm-0";
export var offerCard = "_dm-c";
export var offerIcon = "_dm-e";
export var sectionLabel = "_dm-9";
export var shell = "_dm-1";
export var title = "_dm-6";